import { GlobalState } from "little-state-machine";

export const updateIsUserApplicationsFilterOpen = (state: GlobalState, isUserApplicationsFilterOpen: boolean) => ({
  ...state,
  isUserApplicationsFilterOpen
});
